import {RequestStatus} from "@/libs/product";
import {i18n} from "@/libs/i18n";

export default {
    state() {
        const statuses = {};
        statuses[RequestStatus.APPROVED] = 'primary';
        statuses[RequestStatus.PARTIALLY_APPROVED] = 'primary';
        statuses[RequestStatus.REPLIED] = 'success';
        statuses[RequestStatus.REPLIED_BY_EMAIL] = 'success';
        statuses[RequestStatus.REJECTED] = 'danger';

        const reply = {
            default: {
                border: 'light',
                bg: 'default',
                alert: 'secondary'
            },
            light: {
                border: 'light',
                bg: 'default',
                alert: 'secondary'
            },
            required: {
                border: 'warning',
                bg: 'default',
                alert: 'warning'
            },
            warning: {
                border: 'warning',
                bg: 'default',
                alert: 'warning'
            },
            success: {
                border: 'success',
                bg: 'default',
                alert: 'secondary'
            }
        };

        const flows = {
            verticalSteps: 'Vertical Steps Flow',
            productCard: 'Product Card Flow',
        };

        const monthTranslation = i18n.t('Component(Text):months');
        const sentRequestPageModes = {
            PRODUCT_REQUEST: 'PRODUCT_REQUEST',
            FOLLOW_UP: 'FOLLOW_UP',
        };
        let sentRequestsPageMode = localStorage.getItem('sentRequestsPageMode');
        if (!sentRequestsPageMode) {
            sentRequestsPageMode = sentRequestPageModes.PRODUCT_REQUEST;
        }

        return {
            replyProcessFlowsOptions: [
                {id: 'default', title: 'Default'},
                {id: 'simple', title: 'Simple'},
                {id: 'cellcomb', title: 'Cellcomb'},
                {id: 'fmd', title: 'Full Material Declaration'},
                {id: 'received-request-reply', title: 'Received Request Reply'},
            ],
            replyProcessFlow: {
                DEFAULT: 'default',
                FMD: 'fmd',
                SIMPLE: 'simple',
                CELLCOMB: 'cellcomb',
                RECEIVED_REQUEST_REPLY: 'received-request-reply',
            },
            defaultReplyProcessFlow: 'default',
            received: {
                badgeVariant: statuses,
                replyVariant: reply,
                flows: flows,
                defaultFlow: flows.verticalSteps,

                receivedRequestFlowSwitcherEnvironments: ['qa', 'dev', 'local', 'uat', 'prd', 'prod']
            },
            sent: {
                badgeVariant: statuses,
                replyVariant: reply,

                requestsPage: {
                    modes: sentRequestPageModes,
                    mode: sentRequestsPageMode,
                },
            },
            declarationOfValidityOptions: [
                { month: 6, title: '6 ' + monthTranslation },
                { month: 12, title: '12 ' + monthTranslation },
                { month: 18, title: '18 ' + monthTranslation },
                { month: 24, title: '24 ' + monthTranslation }
            ]
        };
    },

    mutations: {
        setReceivedRequestFlow(state, flow) {
            state.received.defaultFlow = flow;
        },
        setSentRequestsPageMode(state, mode) {
            state.sent.requestsPage.mode = mode;
            localStorage.setItem('sentRequestsPageMode', mode);
        }
    },

    getters: {
        declarationOfValidityOptions(state) {
            return state.declarationOfValidityOptions;
        },
        replyProcessFlowsOptions(state) {
            return state.replyProcessFlowsOptions;
        },
        defaultReplyProcessFlow(state) {
            return state.defaultReplyProcessFlow;
        },
        replyProcessFlow(state) {
            return state.replyProcessFlow;
        }
    },

    actions: {
        changeReceivedRequestFlow({commit}, flow) {
            commit('setReceivedRequestFlow', flow);
        },

        saveSentRequestPageMode({commit}, mode) {
            commit('setSentRequestsPageMode', mode);
        },

        requestRejected() {

        }
    }
};
